<template>
  <div class="mt-10 mb-10 clearfix">
    <div class="col-sm-6">
      <div class="box-list-item border-bottom size-18">
        Total<sup class="color-magenta weight-bold">[1]</sup> <span class="pull-right weight-mid">{{ total | brlPrice }}</span>
      </div>
      <article
        v-for="(item, index) in items"
        :key="`checkout-hotel-item-${index}`"
        :class="{ 'border-bottom': index !== (items.length-1) }"
        class="box-list-item clearfix">
        <div class="col-xs-6 col-sm-9 padding-off">
          <h2 class="size-16 weight-bold margin-off">
            {{ item.room.hotel.name }}
            <span class="size-12 weight-normal color-gray-light">
              {{ item.room.nights }} {{ 'noite' | pluralize(item.room.nights) }},
              {{ item.room.adults }} {{ 'adulto' | pluralize(item.room.adults) }}
            </span><br>
          </h2>
          <!-- Hotel Detail -->
          <hotel-detail :item="item"></hotel-detail>
          <!-- // Hotel Detail -->
        </div>
        <div class="col-xs-6 col-sm-3 padding-off">
          <p class="text-right mt-10">
            {{ item.total | brlPrice }}
          </p>
        </div>
      </article>
    </div>
    <div class="col-sm-6">
      <template v-if="creditCardByProduct">
        <div class="col-sm-10">
          <select-creditcard
            :validation="validation"
            :creditcards="cards"
            name="creditcard_hotel"
            @handleCreditcard="handleCreditcard"></select-creditcard>
        </div>
        <div class="col-sm-12 mt-10">
          <a
            @click.prevent="$emit('handleParentAction', 'card-register')"
            href="#"
            class="btn-link size-14 weight-normal mt-20">+Adicionar Novo Cartão</a>
        </div>
      </template>
      <p class="size-15 weight mt-10"><sup class="color-magenta weight-bold">[1]</sup>
        Cartão cadastro será utilizado para garantia de no show e cobrança de FEE,
        o pagamento será feito direto no hotel conforme política de cobrança de cada hotel.</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HotelDetail from '@/components/hotel/HotelDetail'
import SelectCreditcard from '@/components/fields/SelectCreditcard'

export default {
  components: {
    HotelDetail,
    SelectCreditcard
  },
  props: [
    'order',
    'items',
    'validation',
    'creditcards',
    'creditCardByProduct'
  ],
  computed: {
    ...mapGetters('reserve', ['totalByOrder']),
    total () {
      return this.totalByOrder('hotels')
    },
    cards () {
      return this.creditcards.filter((card) => !card.corporate_virtual_flight)
    }
  },
  methods: {
    handleCreditcard (target) {
      this.$emit('handleCreditcard', target)
    }
  }
};
</script>
